import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const napRefusalAge2: BlogMetaData = {
  title: '2歳が昼寝しない…大丈夫？昼寝がいらなくなるサインと生活リズムの整え方',
  description:
    '2歳が昼寝しないのは異常ではありません。昼寝が不要になり始めるサイン、無理に寝かせない選択と静かな休息時間のつくり方、夜の就寝への影響、相談の目安までモンテッソーリの視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-nap-refusal-age-2.webp',
  filePath: buildBlogFilePath('nap-refusal-age-2'),
  category: BLOG_CATEGORY.PARENTING,
};
